const en =  {
    logo: 'Asset Management',
    menu: {
        user: 'user info',
        stock: 'IT daily asset inventory',
        yearStock: 'Annual inventory of assets',
        mine: 'my assets',
        req: 'application',
        myStock: 'my inventory',
        out: 'outbound',
        stocked: 'stock history',
        take: 'take over',
        hand: 'hand over',
        ipadStock: 'iPad daily asset inventory',
        myIpadStock: 'my iPad assets'
    },
    submit: 'submit',
    submitTip: 'submitting',
    assetNum: 'asset number',
    assetNumTip: 'Scan code or input asset number',
    photoTip1: 'Take photos of equipment serial number',
    photoTip2: 'Take photos of assets as a whole',
    question: 'doubt',
    remarks: 'remarks',
    remarksTip: 'Please input remarks',
    personalInfo: 'personal information',
    username: 'user num',
    mobile: 'mobile',
    realname: 'name',
    modifyInfo: 'modify info',
    language: 'language',
    stock: 'stock',
    stocked: 'stocked',
    details: 'details',
    confirm: 'confirm',
    error_message_submit: 'error_message_submit',
    assetDetails: 'Asset Details',
    inStock: 'in stock',
    heldby: 'heldby',
    heldbyTip: 'Please input heldby name or mobile',
    dept: 'dept',
    location: 'location',
    stockPerson: 'stock person',
    stockTime: 'stock time',
    signTime: 'sign time',
    signStatus: 'sign status',
    signPeople: 'sign people',
    serial: 'serial No',
    storage: 'custodian',
    model: 'asset model',
    mobile_company: 'company phone number',
    bu:'BU',
    user_name: 'user name',
    phone: 'telephone',
    sign_time: 'usage time',
    n_name: 'N+1 name'
}
export default en;
